import Vue from "vue";
import Organization from "../../../common/models/organization";
import Selected from "../store/modules/selected";
import User from "~/models/user";

export default Vue.extend({
  computed: {
    organization: {
      get(): Organization {
        return Selected.organization.get();
      }
    },
    user: {
      get(): User {
        return Selected.currentUser.get();
      }
    },
  }
});